import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import { Eyebrow } from './Eyebrow'

export function EmptyState({ eyebrow, title, children, action, className }: { eyebrow?: string; title: string; children?: ReactNode; action?: ReactNode; className?: string }) {
  return (
    <div className={clsx('grid justify-items-start gap-3 border border-dashed border-gray-300 px-6 py-10', className)}>
      {eyebrow && <Eyebrow tone="muted">{eyebrow}</Eyebrow>}
      <h3 className="text-h4">{title}</h3>
      {children && <p className="max-w-prose text-small text-dim">{children}</p>}
      {action && <div className="pt-2">{action}</div>}
    </div>
  )
}
